import { component, prop } from '../../decorators';

import SOURCES_FOR_EPISODE_MIXIN from '../../mixins/player.sources.mixin';

import Player from '../common/player/player.vue';
import TimedataSwitcher from '../common/timedata-switcher/timedata-switcher.vue';
import MetadataInfo from '../common/metadata-info/metadata-info.vue';

import l10n from '../../transformers/l10n';
import { METADATA_TYPES } from '../../config';

import groupBy from 'lodash/groupBy';
import has from 'lodash/has';

const TYPES = METADATA_TYPES.filter(mt => mt.type !== 'character');

const BASE_SYNOPSIS_LIMIT = 300;

@component({
   components: { Player, TimedataSwitcher, MetadataInfo },
   mixins: [ SOURCES_FOR_EPISODE_MIXIN ]
})
export default class EpisodeInfo {
   @prop({ type: Object, required: true }) episode
   @prop({ type: Array, required: true }) metadata
   @prop({ type: Array, required: true }) timedata

   synopsisLength = BASE_SYNOPSIS_LIMIT
   currentTime = 0 // eslint-disable-line no-magic-numbers

   get sourcesWitoutCC() {
      return { ...this.sources, cc: null };
   }

   get metadataAsMap() {
      return groupBy(this.metadata, 'type');
   }

   get characters() {
      return this.metadataAsMap.character.map(character => {
         const timedata = this.timedateAsMap[character.id] || [];
         return { ...character, timedata };
      });
   }

   get timedateAsMap() {
      return groupBy(this.timedata, 'metadataId');
   }

   get groupedMetadata() {
      const data = this.metadataAsMap;
      const { timedateAsMap } = this;
      return TYPES.reduce((memo, {type, tk}) => {
         if ( has(data, type) ) {
            const types = data[type].map( metadata => {
               const label = metadata.name;
               const timedata = timedateAsMap[metadata.id] || [];
               return { label, timedata };
            });
            memo.push({ type, label: l10n(tk), types });
         }
         return memo;
      }, []);
   }

   changeCurrentTime(time) {
      this.$refs.player.setCurrentTime(time);
   }

   timeupdate(time) {
      this.currentTime = time;
   }
}
